import React from 'react';
import NextImage from '../NextImage';
import App from '../../package.json'
import Link from 'next/link';
import Image from 'next/image';
import BackToTop from './back-to-top';

const FooterLogo = () => {
    return (
        <div className="max-w-7xl px-2 md:max-w-4xl relative mx-auto overflow-hidden">
            <div className="mt-8 footer-nav text-[#6B7280]">
                <div className="flex flex-col items-center gap-8 mb-8">

                    <BackToTop />

                    {/* Links Section */}
                    <div className="flex sm:flex-wrap items-center justify-center md:justify-center gap-y-4 md:gap-4 text-center w-full max-w-md pb-8">
                        <Link aria-label="community" className="mr-5 transition-all duration-300 hover:underline md:w-fit" href="/circles">
                            Community
                        </Link>
                        <Link aria-label="contact-us" className="mr-5 transition-all duration-300 hover:underline md:w-fit" href="/contact-us">
                            Contact Us
                        </Link>
                        <Link aria-label="terms" className="mr-5 transition-all duration-300 hover:underline md:w-fit" href="/terms-of-use">
                            Terms
                        </Link>
                        <Link aria-label="privacy" className="transition-all duration-300 hover:underline md:w-fit" href="/privacy-policy">
                            Privacy
                        </Link>
                    </div>

                    <div className='border-b border-[#EAECF0] w-full'></div>


                </div>
            </div>

            <div className='flex justify-between sm:flex-col items-center gap-10 mb-10 md:px-5'>
                <div>
                    {/* Social Media Section */}
                    <div className="relative flex gap-7 items-start">
                        <Link aria-label='instagram' href="https://www.instagram.com/hyqoo_com/" target="_blank" rel="noopener noreferrer">
                            <NextImage className='w-[20px] h-[20px]' src="https://hyqoo.b-cdn.net/WebsiteAssets/images/instagram.svg" alt="Instagram" />
                        </Link>
                        <Link aria-label='facebook' href="https://www.facebook.com/profile.php?id=100082139799271&mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer">
                            <NextImage className='w-[20px] h-[20px]' src="https://hyqoo.b-cdn.net/WebsiteAssets/images/facebook.svg" alt="Facebook" />
                        </Link>
                        <Link aria-label='twitter' href="https://twitter.com/hyqoo_com" target="_blank" rel="noopener noreferrer">
                            <NextImage className='w-[20px] h-[20px]' src="https://hyqoo.b-cdn.net/WebsiteAssets/images/twitter.svg" alt="Twitter" />
                        </Link>
                        <Link aria-label='linkedin' href="https://www.linkedin.com/company/hyqooformelycliksource/" target="_blank" rel="noopener noreferrer">
                            <NextImage className='w-[20px] h-[20px]' src="https://hyqoo.b-cdn.net/WebsiteAssets/images/linkedin.svg" alt="LinkedIn" />
                        </Link>
                    </div>

                    {/* Copyright Section */}
                    <div className="text-[#9CA3AF] text-start mt-6">
                        © {new Date()?.getFullYear()} Hyqoo LLC. All rights reserved.<br />
                        110 Allen Road, Basking Ridge, New Jersey 07920.<br />
                        V{App?.version}
                    </div>
                </div>
                {/* <div className="flex gap-7 md:gap-4 flex-wrap items-center justify-center">
                    <img src='/icons/iso.png' alt='iso' className='invert w-28 h-auto md:w-20 md:h-auto xs:w-16 xs:h-auto' />
                    <img src='/icons/hr6.svg' alt='hr76' className='w-28 h-28 md:w-20 md:h-20 xs:w-16 xs:h-16' />
                    <img src='/icons/hr8.svg' alt='hr76' className='w-28 h-28 md:w-20 md:h-20 xs:w-16 xs:h-16' />
                    <img src='/icons/hr3.svg' alt='hr76' className='w-28 h-28 md:w-20 md:h-20 xs:w-16 xs:h-16' />
                    <img src='/icons/hr76.svg' alt='hr76' className='w-28 h-28 md:w-20 md:h-20 xs:w-16 xs:h-16' />
                </div> */}

                <div className="flex gap-7 h-full md:gap-4 flex-wrap items-center justify-center">
                    <Image
                        src="https://hyqoo.b-cdn.net/WebsiteAssets/icons/iso.png"
                        alt="ISO"
                        width={112} // Adjust based on actual need
                        height={112}
                        className="invert"
                    />
                    {
                        ['hr6', 'hr8', 'hr3', 'hr76']?.map((icon, index) => (
                            <Image
                                key={index}
                                src={`https://hyqoo.b-cdn.net/WebsiteAssets/webp/${icon}.webp`}
                                alt={icon}
                                width={112} // Adjust based on actual need
                                height={112}
                            />
                        ))
                    }
                </div>
            </div>

            {/* Logo */}
            <div className="w-full overflow-hidden footer-logo">
                <svg fill="none" viewBox="0 0 1112 394" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M171.213 108.954H44.988V.928H.832v292.624h44.156V156.904h126.225v136.648h44.161V.928h-44.161v108.026Zm473.305 135.509c-9.734 10.868-22.429 16.302-38.092 16.302-14.787 0-26.982-5.686-36.582-17.059-9.6-11.116-14.405-25.585-14.405-43.398 0-16.302 4.864-30.073 14.593-41.317 9.858-11.116 22.108-16.679 36.77-16.679 15.539 0 28.176 5.493 37.909 16.485 9.724 11.245 14.588 25.526 14.588 42.838 0 17.561-4.923 31.837-14.781 42.828Zm12.131-115.421c-16.807-16.803-35.888-25.209-57.238-25.209-25.144 0-46.057 9.357-62.736 28.052-16.554 18.828-24.822 42.263-24.822 70.315 0 27.67 8.268 50.729 24.822 69.176 16.426 18.323 37.087 27.482 61.979 27.482 21.731 0 41.064-8.654 57.995-25.966V394h42.833V108.95h-42.833v20.092Zm355.961 131.729c16.68 0 30.01-5.37 40-16.109 9.97-10.739 14.97-25.08 14.97-43.021 0-17.942-5-32.282-14.97-43.027-10.11-10.863-23.44-16.297-40-16.297-16.295 0-29.501 5.434-39.601 16.297-10.11 10.868-15.173 24.892-15.173 42.075 0 18.452 4.929 33.045 14.792 43.78 10.11 10.873 23.43 16.302 39.982 16.302Zm-182.228 0c16.679 0 30.009-5.37 39.995-16.109 9.977-10.739 14.975-25.08 14.975-43.021 0-17.942-4.998-32.282-14.975-43.027-10.11-10.863-23.44-16.297-39.995-16.297-16.297 0-29.503 5.434-39.603 16.297-10.11 10.868-15.168 24.892-15.168 42.075 0 18.452 4.924 33.045 14.787 43.78 10.11 10.873 23.43 16.302 39.984 16.302Zm182.228-156.928c27.55 0 50.92 9.417 70.13 28.24 18.95 18.829 28.43 41.952 28.43 69.364 0 27.671-9.54 50.863-28.61 69.558-19.21 18.575-42.78 27.863-70.7 27.863-27.676 0-50.863-9.481-69.563-28.433-9.084-9.08-15.92-19.324-20.592-30.677-4.77 11.527-11.888 21.944-21.379 31.247-19.21 18.575-42.774 27.863-70.697 27.863-27.675 0-50.857-9.481-69.562-28.433-18.699-18.695-28.042-42.199-28.042-70.503 0-26.66 9.536-49.337 28.612-68.037 19.081-18.699 42.328-28.052 69.745-28.052 27.552 0 50.923 9.417 70.127 28.24 9.263 9.204 16.228 19.448 20.964 30.702 4.77-11.279 11.898-21.582 21.394-30.89 19.081-18.699 42.328-28.052 69.743-28.052Zm-752.277 5.103 85.21 142.304-85.21 142.746h52.071l83.863-142.746-83.863-142.304h-52.071Zm132.211 37.255c0-23.401 18.967-42.368 42.367-42.368 23.401 0 42.368 18.967 42.368 42.368 0 23.4-18.967 42.367-42.368 42.367-23.4 0-42.367-18.967-42.367-42.367Z" fill="url(#a)"></path>
                    <defs>
                        <linearGradient id="a" x1=".832" y1="171.835" x2="1304.11" y2="171.835" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#C3C7D5"></stop>
                            <stop offset="1" stopColor="#C3C7D5" stopOpacity="0"></stop>
                        </linearGradient>
                    </defs>
                </svg>
            </div>
        </div>
    );
};

export default FooterLogo;
